/* Model */
class LocationTypeModel extends App.Models.BaseModel {
    modelUrl = 'LocationType';

    constructor() {
        super();
        this.organization = new App.Models.Organization;
    }
}

App.Models.LocationType = LocationTypeModel;

/* Collection */
class LocationTypeCollection extends App.Collections.BaseCollection {
    url = 'LocationType';
    model = App.Models.LocationType;
}

App.Collections.LocationTypes = LocationTypeCollection;

/* Router */
class LocationTypeRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'LocationType';
        const model = App.Models.LocationType;
        const collectionClass = App.Collections.LocationTypes;

        super(entityName, model, collectionClass);
    }
}

App.Routers.LocationType = LocationTypeRouter;
